/* Featured Success Stories -> #sa-revtop (visible "What Members Say" cards).
   Safety model for a live sales page:
   - The 5 baked <div class="sa-rc"> cards stay server-rendered as the fallback
     (SEO + instant paint + shown if the endpoint is down and there is no cache).
   - On successful fetch with >=1 featured story: replace the visible cards with
     the featured set and cache it (localStorage).
   - On successful fetch that is EMPTY (all toggled off): hide the whole section
     (heading + cards) so "toggling off removes it from the live site" -- never an
     empty shell.
   - On fetch FAILURE: render the cached copy if present; otherwise leave the baked
     cards. Never blank, never a broken container. */
(function () {
  var TOP = document.getElementById('sa-revtop');
  var SEC = document.getElementById('sa-reviews');
  if (!TOP || !SEC) return;
  var CK = 'sa_featured_reviews_v1';
  var URL = 'https://mission-control.streignth.com/api/public/success-stories';

  function esc(s) { var d = document.createElement('div'); d.textContent = (s == null ? '' : String(s)); return d.innerHTML; }
  function stars(n) { n = parseInt(n, 10); if (!(n >= 1 && n <= 5)) n = 5; var o = ''; for (var i = 0; i < n; i++) o += '★'; return o; }
  function card(r) {
    var dt = r.date ? '<span class="sa-rc-dt">' + esc(r.date) + '</span>' : '';
    return '<div class="sa-rc"><div class="sa-rc-h"><span class="sa-rc-st">' + stars(r.star_rating) +
      '</span><span class="sa-rc-nm">' + esc(r.display_name) + '</span></div><p class="sa-rc-tx">' +
      esc(r.text) + '</p>' + dt + '</div>';
  }
  function render(list) { TOP.innerHTML = list.map(card).join(''); SEC.style.display = ''; }

  // Cache-first for an instant, correct paint on repeat visits.
  try { var c = JSON.parse(localStorage.getItem(CK) || 'null'); if (c && c.length) render(c); } catch (e) {}

  fetch(URL, { cache: 'no-store' })
    .then(function (r) { if (!r.ok) throw 0; return r.json(); })
    .then(function (j) {
      var list = (j && j.stories) || [];
      if (list.length) { render(list); try { localStorage.setItem(CK, JSON.stringify(list)); } catch (e) {} }
      else { SEC.style.display = 'none'; try { localStorage.removeItem(CK); } catch (e) {} }
    })
    .catch(function () { /* endpoint down: keep the baked cards or the cache already shown; never blank */ });
})();
